module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-02-ipad-frame.eaf1d7d6.png";